import React from 'react';
import EventList from '../components/event/EventList';

export default function EventsPage() {
    return <EventList />;
}
